/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var ActionRequestStatus;
(function (ActionRequestStatus) {
    ActionRequestStatus["DRAFT"] = "DRAFT";
    ActionRequestStatus["ACTIVE"] = "ACTIVE";
    ActionRequestStatus["ARCHIVED"] = "ARCHIVED";
})(ActionRequestStatus || (ActionRequestStatus = {}));
